import { render } from "./NewDataTable.vue?vue&type=template&id=647cc32a&scoped=true"
import script from "./NewDataTable.vue?vue&type=script&lang=js"
export * from "./NewDataTable.vue?vue&type=script&lang=js"

import "./NewDataTable.vue?vue&type=style&index=0&id=647cc32a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647cc32a"]])

export default __exports__